import { StyleSheet, View } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import { formatHoursReadable } from '@/lib/dates'

export function PeriodTotal({ totalHours }: { totalHours: number }) {
    const theme = useTheme()

    return (
        <View style={[styles.container, { borderTopColor: theme.colors.outlineVariant }]}>
            <Text variant="labelMedium" style={{ color: theme.colors.onSurfaceVariant, flex: 1 }}>
                Period Total
            </Text>
            <Text variant="titleMedium" style={{ fontWeight: 'bold', color: theme.colors.primary }}>
                {formatHoursReadable(totalHours)}
            </Text>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 12,
        paddingLeft: 16,
        paddingRight: 48,
        borderTopWidth: 1,
    },
})
